import { useTranslation } from 'react-i18next';
import { ActionItemButton } from '@components/button/action-item-button';
import { ActionItemLockedButton } from '@components/button/action-item-locked-button';
import { IconCreateEvent } from '@components/icons/icon-create-event';
import { ModalV2 } from '@components/modals/modal-v2/modal-v2';
import { ActionModalType } from '@contexts/modal/modal.type';

import { ActionButtonModalProps } from './action-button-modal.type';

export const ActionButtonModal = ({
  open,
  setIsOpen,
  navigateToCreateEvent,
  createEventDisabledReason,
  toggleModal,
  actions,
}: ActionButtonModalProps) => {
  const { t } = useTranslation();
  const handleClickAction = (type: ActionModalType) => {
    toggleModal({ type });
    setIsOpen(false);
  };
  return (
    <ModalV2
      isOpen={open}
      hasMobileHandle
      onClose={() => {
        setIsOpen(false);
      }}>
      <div className='flex flex-col w-full pt-4 pb-10 px-4 gap-3 bg-primary'>
        {Object.entries(actions).map(([key, value]) => {
          const Icon = value.icon;
          return (
            <ActionItemButton
              key={key}
              Icon={Icon}
              active={false}
              text={t(`common:actionModal${value.name}Button`)}
              onClick={() => {
                handleClickAction(key as ActionModalType);
              }}
            />
          );
        })}
        {navigateToCreateEvent && createEventDisabledReason && (
          <ActionItemLockedButton
            text={t('eventList:buttonCreateEvent')}
            reason={createEventDisabledReason}
            Icon={IconCreateEvent}
            dataTestId='action-button-modal--create-event-locked'
          />
        )}
        {navigateToCreateEvent && !createEventDisabledReason && (
          <ActionItemButton
            active={false}
            onClick={() => {
              setIsOpen(false);
              navigateToCreateEvent();
            }}
            text={t('eventList:buttonCreateEvent')}
            Icon={IconCreateEvent}
          />
        )}
      </div>
    </ModalV2>
  );
};
